import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import { useRequest } from 'ahooks';
import Toast from '@src/components/toast';

import routeConfigs from '@src/pages/app-router/route-configs';
import reloadWhenPageShowByCache from '@src/utils/reload-when-page-show-by-cache';
import PageLayoutStore from '@src/business-components/page-layout/store';
import ArticleBtnStore from '@src/business-components/article-btn/store';
import { getOmniData, getOmniDetail, NewsChannelId } from '@src/services/omni-api';
import { HIDE_DATA } from '@src/constants/urls';
import { createContentRouteUrl, getContentRouteQuery } from '@src/utils/content-route-util';
class NewsDetailStore extends BaseStore {
  @observable hideData = HIDE_DATA;

  articleBtnStore = new ArticleBtnStore();
  pageLayoutStore = new PageLayoutStore({
    type: '江湖快报',
    isHideStrategy: () => this.hideData
  });
  //目录id
  @observable categoryId;

  //文章id
  @observable contentId;

  //文章内容
  @observable currentArticle;

  @observable page;

  @observable pageSize = 10;

  @observable list;

  /**
   * 获取文章id
   */
  getContentId = () => {
    const { contentId, categoryId, page } = getContentRouteQuery(this.$routeMatch.query);
    this.categoryId = categoryId;
    this.contentId = contentId;
    this.page = Number(page) || 1;
    if (this.contentId) {
      this.getNewsDetailRequest.run();
      this.getNewsListRequest.run();
      this.pageLayoutStore.breadcrumbNavStore.navItems = [
        {
          label: '官网首页',
          path: routeConfigs.MAIN.getFormatPath({ part: 'news' })
        },
        { label: '江湖快报', href: createContentRouteUrl('/news-list', { categoryId: this.categoryId }) },
        { label: '正文', href: createContentRouteUrl('/news-detail', { categoryId: this.categoryId, contentId: this.contentId, page: this.page }) }
      ];
    }
  };

  setArticleBtn = async detailList => {
    const contentId = this.contentId;
    // 设置 上一页、下一页数据
    const index = detailList.findIndex(item => item.contentId === contentId);
    let newPage = this.page;
    if (index === 0) {
      // index为0,判断前面是否还有页数
      if (this.page === 1) {
        this.articleBtnStore.prevData = {};
      } else {
        newPage = newPage - 1;
        const prevRes = await getOmniData(NewsChannelId, [
          {
            dataSourceId: this.categoryId,
            page: this.page - 1,
            perPage: this.pageSize
          }
        ]);
        this.articleBtnStore.prevData = prevRes?.[this.categoryId]?.result?.items?.[prevRes?.[this.categoryId]?.result?.items?.length - 1] || {};
      }
      this.articleBtnStore.nextData = detailList[index + 1] || {};
    } else if (index === detailList.length - 1) {
      newPage = newPage + 1;
      // index=最后一项,判断后面是否还有数据
      const nextRes = await getOmniData(NewsChannelId, [
        {
          dataSourceId: this.categoryId,
          page: this.page + 1,
          perPage: this.pageSize
        }
      ]);
      this.articleBtnStore.prevData = detailList[index - 1] || {};
      this.articleBtnStore.nextData = nextRes?.[this.categoryId]?.result?.items?.[0] || {};
    } else {
      this.articleBtnStore.prevData = detailList[index - 1] || {};
      this.articleBtnStore.nextData = detailList[index + 1] || {};
    }
    this.articleBtnStore.gotoDetail = item => {
      if (item.jump_link === 'link') {
        window.open(item.art_link.url);
      } else {
        window.location.href = createContentRouteUrl('/news-detail', { categoryId: this.categoryId, contentId: item.contentId, page: newPage });
      }
    };
  };

  getNewsDetailAsync = () => {
    return getOmniDetail(this.contentId)
      .then(res => {
        this.currentArticle = res;
        // console.log('news detail res:', res);
      })
      .catch(error => {
        Toast.fail(error.msg);
      });
  };

  getNewsListAsync = () => {
    // console.log(this.page);
    return getOmniData(NewsChannelId, [
      {
        dataSourceId: this.categoryId || '',
        page: parseInt(this.page, 10),
        perPage: this.pageSize
      }
    ])
      .then(res => {
        this.list = res[this.categoryId].result.items;
        this.setArticleBtn(res[this.categoryId].result.items);
      })
      .catch(error => {
        Toast.fail(error.msg);
        console.log('news detail error:', error);
      });
  };
  use() {
    super.use();

    this.getNewsDetailRequest = useRequest(
      async () => {
        await this.getNewsDetailAsync();
      },
      { manual: true }
    );

    this.getNewsListRequest = useRequest(
      async () => {
        await this.getNewsListAsync();
      },
      { manual: true }
    );

    useMount(() => {
      reloadWhenPageShowByCache();
      this.getContentId();
    });
  }
}

export default NewsDetailStore;
